var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bidding-interface"},[_c('V2Auction',{attrs:{"diagram":_vm.diagram,"selectedBid":_vm.selectedBid,"isConfirmed":_vm.isConfirmed,"disabled":_vm.disabled},on:{"select-bid":_vm.selectBid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }